// @ts-nocheck
import fastenersTableReducer, {
    FastenersTableActions,
} from "@store/Framework/Store/Store/Components/FastenersTable/FastenersTableReducer";
import { combineReducers } from "redux";

const componentsReducer = combineReducers({
    fastenersTable: fastenersTableReducer,
});

export type ComponentsActions = FastenersTableActions;

export default componentsReducer;
